import { render, staticRenderFns } from "./matching-question-solution-component.vue?vue&type=template&id=396acfca&scoped=true&"
import script from "./matching-question-solution-component.vue?vue&type=script&lang=ts&"
export * from "./matching-question-solution-component.vue?vue&type=script&lang=ts&"
import style0 from "./matching-question-solution-component.vue?vue&type=style&index=0&id=396acfca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396acfca",
  null
  
)

export default component.exports